import debounce from 'debounce'

/*
 * Handle masonry layout of sokeresultat.
 *
 * Once css masonry gets wide support, this element can be removed.
 * */
export class SexguidenSokeresultat extends HTMLElement {
  _columnWidth = 350
  _columnGap = 30
  _rowGap = 27
  _rowGapSmall = 14

  connectedCallback() {
    this._updatePositions()
    this._debouncedUpdatePositions = debounce(this._updatePositions, 300)
    window.addEventListener('resize', this._debouncedUpdatePositions)
    this.images.forEach((img) => {
      img.addEventListener('load', this._debouncedUpdatePositions)
    })
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._debouncedUpdatePositions)
    this.images.forEach((img) => {
      img.removeEventListener('load', this._debouncedUpdatePositions)
    })
  }

  _updatePositions = () => {
    const containerWidth = this.stillingContainer.offsetWidth
    const nrOfColumns = Math.max(
      1,
      Math.floor((containerWidth + this._columnGap) / (this._columnWidth + this._columnGap))
    )
    const rowGap = nrOfColumns === 1 ? this._rowGapSmall : this._rowGap
    const columnStarts = [...new Array(nrOfColumns)].map(() => 0)
    const columnWidth = (containerWidth + this._columnGap) / nrOfColumns - this._columnGap

    const stillinger = [...this.stillinger]
    /* Size elements */
    for (const stilling of stillinger) {
      stilling.style.position = 'absolute'
      stilling.style.width = `${columnWidth}px`
    }

    /* Measure heights */
    const heights = stillinger.map((stilling) => stilling.offsetHeight)

    /* Position elements */
    // eslint-disable-next-line compat/compat
    for (const [idx, stilling] of Object.entries(stillinger)) {
      const minStartPosition = Math.min(...columnStarts)
      const columnIndex = columnStarts.findIndex((start) => start === minStartPosition)
      stilling.style.top = `${columnStarts[columnIndex]}px`
      stilling.style.left = `${columnIndex * (columnWidth + this._columnGap)}px`
      /* Update column column start position */
      const stillingHeight = heights[idx]
      columnStarts[columnIndex] += stillingHeight + rowGap
    }

    /* Size container */
    this.stillingContainer.style.height = `${Math.max(...columnStarts)}px`
  }

  get stillingContainer() {
    return this.querySelector('ul')
  }

  get stillinger() {
    return this.querySelectorAll('li')
  }

  get images() {
    return this.querySelectorAll('li img')
  }
}
